import React, { PureComponent } from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';

import config from '../../../../config';
import Auth from '../../libs/Auth';

import Trades from './Trades';
import Payments from './Payments';
import Users from './Users';
import MyAccount from './MyAccount';
import Channels from './Channels';
import Offers from './Offers';
import Tracking from './Tracking';
import Health from './Health';
import Files from './Files';
import Ledger from './Ledger';
import BitcoinTrades from './BitcoinTrades';
import CryptoTransactions from './CryptoTransactions';
import Data from './Data';
import BalanceSelling from './BalanceSelling';

class WorkAreaView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    const { match, logout, rateLimitRemaining } = this.props;
    return (
      <div>
        <ul className="menu">
          <li>
            <NavLink to="/" exact={true} activeClassName="is-active">Open Trades</NavLink>
          </li>
          <li>
            <NavLink to="/workArea/trades/completed" activeClassName="is-active">Completed Trades</NavLink>
          </li>
          {Auth.isType(['admin', 'manager']) && (
            <li>
              <NavLink to="/workArea/payments" activeClassName="is-active">Payments</NavLink>
            </li>
          )}
          {Auth.isType(['admin', 'manager']) && (
            <li>
              <NavLink to="/workArea/channels" activeClassName="is-active">Channels</NavLink>
            </li>
          )}
          <li>
            <NavLink to="/workArea/myAccount" activeClassName="is-active">My Account</NavLink>
          </li>
          {Auth.isType(['admin']) && (
            <li>
              <NavLink to="/workArea/users" activeClassName="is-active">Users</NavLink>
            </li>
          )}
          {Auth.isType(['admin']) && (
            <li>
              <NavLink to="/workArea/tracking" activeClassName="is-active">Tracking</NavLink>
            </li>
          )}
          <li>
            <NavLink to="/workArea/offers" activeClassName="is-active">Offers</NavLink>
          </li>
          {Auth.isType(['admin', 'manager']) && (
            <li>
              <NavLink to="/workArea/files" activeClassName="is-active">Files</NavLink>
            </li>
          )}
          {config.features.Ledger && Auth.isType(['admin']) && (
            <li>
              <NavLink to="/workArea/ledger" activeClassName="is-active">Ledger</NavLink>
            </li>
          )}
          {config.features.BTC && Auth.isType(['admin']) && (
            <li>
              <NavLink to="/workArea/bitcoin-trades" activeClassName="is-active">BTC</NavLink>
            </li>
          )}
          <li>
            <NavLink to="/workArea/health" activeClassName="is-active">Health</NavLink>
          </li>
          <li>
            <NavLink to="/workArea/data" activeClassName="is-active">Data</NavLink>
          </li>
          {config.features.balanceSelling && Auth.isType(['admin']) && (
            <li>
              <NavLink to="/workArea/balance-selling" activeClassName="is-active">Transactions</NavLink>
            </li>
          )}
          {config.features.BOT && Auth.isType(['admin']) && (
            <li>
              <NavLink to="/workArea/crypto-transactions" activeClassName="is-active">Bot</NavLink>
            </li>
          )}
        </ul>
        <ul className="menu align-right logout-menu">
          {config.features.Ebay && (
            <li>
              <NavLink to="/ebay" activeClassName="is-active">Ebay</NavLink>
            </li>
          )}
          <li>
            <a href="#" onClick={e=>{
              e.preventDefault();
              logout();
            }}>Logout</a>
          </li>
        </ul>
        <div className="rate-limit-remaining">{rateLimitRemaining}</div>
        <Switch>
          <Route path={match.url} exact component={Trades}/>
          <Route path={`${match.url}/trades/:context`} component={Trades}/>
          <Route path={`${match.url}/payments`} component={Payments}/>
          <Route path={`${match.url}/channels`} component={Channels}/>
          <Route path={`${match.url}/myAccount`} component={MyAccount}/>
          <Route path={`${match.url}/users`} component={Users}/>
          <Route path={`${match.url}/offers`} component={Offers}/>
          <Route path={`${match.url}/tracking`} component={Tracking}/>
          <Route path={`${match.url}/health`} component={Health}/>
          <Route path={`${match.url}/files`} component={Files}/>
          <Route path={`${match.url}/ledger`} component={Ledger}/>
          <Route path={`${match.url}/bitcoin-trades`} component={BitcoinTrades}/>
          <Route path={`${match.url}/crypto-transactions`} component={CryptoTransactions}/>
          <Route path={`${match.url}/data`} component={Data}/>
          <Route path={`${match.url}/balance-selling`} component={BalanceSelling}/>
        </Switch>
      </div>
    );
  }
}

export default WorkAreaView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/WorkArea.view.js